/**
 * @see From https://contactform7.com/dom-events/
**/ 

import Misc from './misc';

document.addEventListener('DOMContentLoaded', function() {

  const contactFormElement =  document.querySelector('.wpcf7');
  const isMobile = Misc.getViewport().width < Misc.getMediaQueries()['mobile-layout'];  
  
  if(!contactFormElement) {
    return false;
  }

  const contactForm = {
    addLoadingClass() {
      return contactFormElement.classList.add('is-loading')
    },
    removeLoadingClass() {
      return contactFormElement.classList.remove('is-loading')
    },
  }

  contactFormElement.addEventListener('submit', () => {
    contactForm.addLoadingClass();
  });

  contactFormElement.addEventListener('wpcf7submit', () => {
    if (contactFormElement.classList.contains('is-loading')) {
      contactForm.removeLoadingClass();
    }
  }, false);

  contactFormElement.addEventListener('wpcf7mailsent', () => {
    contactFormElement.classList.add('mailsent');
    if (isMobile) {
      
      const target = document.querySelector('.wpcf7-form');
      const offsetAdminBar = document.body.classList.contains('user-logged-in') ? document.querySelector('#wpadminbar').getBoundingClientRect().height : 0;
      const offsetHeader = document.querySelector('.site-header').getBoundingClientRect().height;
      const offset = parseInt(offsetAdminBar) + parseInt(offsetHeader) + 10;
      Misc.scrollTo2(target, 300, parseInt(offset));
      return false;
    }
  }, false);

});





